import { OrganizationType } from '@cast/types';

import { useViewedOrganization } from '@cast/infrastructure-organization';

export const useIsViewingEnterpriseOrg = () => {
  const viewedOrganization = useViewedOrganization();

  return viewedOrganization?.type === OrganizationType.ENTERPRISE;
};
